import { RelatedPage, PageData } from "@plinknz/tah-website-elements";
import * as React from "react";
import { Link } from "react-router-dom";
import { generate } from "shortid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { byPrefixAndName } from "@awesome.me/kit-d560caf08c/icons/modules";

import { PanuiNavigation } from "./panui-navigation";

interface MenuProps {
  links?: RelatedPage[];
  parent?: RelatedPage;
  currentPage: PageData;
  show: boolean;
  panuiDate?: string;
}

export const Menu = ({
  links = [],
  show,
  parent,
  currentPage,
  panuiDate,
}: MenuProps) => {
  const renderLink = ({ slug, title }: RelatedPage, index: number) => (
    <Link
      key={slug + index + generate()}
      className="menu-link button"
      title={title}
      to={slug}
    >
      <span className="menu-link-text">{title}</span>
    </Link>
  );
  const getParentsAsArray = (page: RelatedPage) => {
    let currentParent = page;
    const breadcrumbs = [];
    while (currentParent && "parent" in currentParent) {
      breadcrumbs.push(currentParent);
      currentParent = currentParent.parent;
    }

    return breadcrumbs.reverse();
  };

  const breadcrumbs = getParentsAsArray(parent);

  if ((!show || links.length === 0) && breadcrumbs.length === 0) {
    return null;
  }

  return (
    <div className="menu" data-testid="menu-container">
      {show && links.length > 0 && (
        <div className="menu-links" data-testid="menu">
          <div className="constrain-width">
            {/* <h6 className="heading-6">Related pages:</h6> */}
            <div className="menu-list">{links.map(renderLink)}</div>
          </div>
        </div>
      )}
      {breadcrumbs.length > 0 && (
        <div
          className="menu-breadcrumb || constrain-width"
          data-testid="menu-breadcrumbs"
        >
          {breadcrumbs.map((breadcrumb) => (
            <span key={generate()}>
              <Link
                className="menu-breadcrumb-item linked"
                to={breadcrumb.slug}
              >
                {breadcrumb.title}
              </Link>{" "}
              <FontAwesomeIcon
                icon={byPrefixAndName.fas["chevron-right"]}
                className="menu-breadcrumb-divider"
              />
            </span>
          ))}
          <span className="menu-breadcrumb-item">{currentPage.title}</span>
          {panuiDate && <PanuiNavigation panuiDate={panuiDate} />}
        </div>
      )}
    </div>
  );
};
